module.exports = __webpack_public_path__ + "img/monitor01.3371881f.png";